function take(array, n) {
    return array.slice(0, n);
}
function isAnyOf(value, options) {
    return options.includes(value);
}
export { isAnyOf, take };
